import { useStore } from '@assets/model/Store';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { Split } from '../Split/Split';
import { ProjectFiles } from './ProjectFiles';
import { FileViewerPanel } from '../FileViewerPanel/FileViewerPanel';
import * as style from './ProjectFilesPage.module.less';
import noOutputsAnimation from '@assets/page/no_outputs_animation.webm';
export const ProjectFilesPage = observer(() => {
    const [fileData, setFileData] = useState({
        url: null,
        displayName: null
    });

    const store = useStore();

    const requestSeeFile = (fileUrl: string, displayName: string) => {
        setFileData({ url: fileUrl, displayName: displayName });
    };
    useEffect(() => {
        if (store.selectedReportId) {
            const pdfViewUrl = store.query.value('pdfViewUrl');
            if (pdfViewUrl != 'N/A') {
                requestSeeFile(
                    store.query.value('pdfViewUrl'),
                    store.selectedReportId
                );
            } else {
                const projectFilesRaw = store.projectFiles?.files || {};
                const projectFileKeys = Object.keys(projectFilesRaw);
                if (projectFileKeys.length > 0) {
                    const fileUrl = projectFilesRaw[projectFileKeys[0]].url;
                    requestSeeFile(
                        fileUrl,
                        projectFilesRaw[projectFileKeys[0]].filename
                    );
                }
            }
        }
    }, [store.selectedReportId]);

    const projectFileCount = Object.keys(
        store.projectFiles?.files || {}
    ).length;

    const hasFiles = projectFileCount > 0;

    return (
        // Case Files is a static 50/50 layout (no resize) — the file list and the
        // viewer form one flush container, per the design.
        <Split layoutPercent={[50, 50]} spaceBetween={0}>
            <ProjectFiles requestSeeFile={requestSeeFile} />
            {hasFiles ? (
                <FileViewerPanel
                    fileName={fileData.url}
                    title_display={fileData.displayName}
                    joined={true}
                />
            ) : (
                <div className={style.emptyState}>
                    <video
                        className={style.emptyStateVideo}
                        src={noOutputsAnimation}
                        autoPlay
                        loop
                        muted
                        playsInline
                        controls={false}
                        disablePictureInPicture
                        disableRemotePlayback
                        onContextMenu={e => e.preventDefault()}
                    />
                    <div className={style.emptyStateText}>
                        No items to show yet
                    </div>
                </div>
            )}
        </Split>
    );
});
